export enum SystemActionName {
  None = "", // Keep None at the top, alphabetize below

  ChallengeSessionStart = "ChallengeSessionStart",
  ChallengeSuccess = "ChallengeSuccess",
  ChallengeTimeout = "ChallengeTimeout",
  GetOneTimeCodeComplete = "GetOneTimeCodeComplete",
  GetOneTimeCodeError = "GetOneTimeCodeError",
}
